import { render } from "./Website.vue?vue&type=template&id=10ee7c28&scoped=true"
import script from "./Website.vue?vue&type=script&lang=js"
export * from "./Website.vue?vue&type=script&lang=js"

import "./Website.vue?vue&type=style&index=0&id=10ee7c28&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ee7c28"]])

export default __exports__